function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.871 4.226v16.129m-3.139 0h6.249m-14.937-9.68l3.762-8.6 3.75 8.6m2.793-8.6H3.194m5.376 8.602a3.764 3.764 0 11-7.527 0H8.57zm16.128-.002l-3.763-8.6-3.749 8.6m-2.794-8.6h8.156m-5.376 8.602a3.764 3.764 0 107.527 0h-7.527zm-5.914-8.064a1.613 1.613 0 103.229 0 1.613 1.613 0 00-3.23 0z",
  stroke: "#FFF",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgTerms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21
  }, props), _ref);
}

export default SvgTerms;